import axios from "axios";
import { getToken } from "./auth";

const defaultErrorMessage = "Ошибка во время выполнения запроса. ";
const networkErrorMessage = "Не удалось подключиться к серверу.";

// для предотвращения множественных срабатываний при истечении токена
let isLoggingOut = false;

// Базовый экземпляр axios
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Интерсептор для добавления токена авторизации к каждому запросу
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Интерсепторы для обработки ответов
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // console.error("Fetch error:", error);

    // токен истек или невалиден
    if (error?.response?.status === 401) {

      if (!isLoggingOut) {
        isLoggingOut = true;
        
        alert("Сессия истекла, пожалуйста, войдите снова");
        
        // очищаем данные пользователя
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
 
        window.location.href = "/";
      }
      
      return new Promise(() => {}); 
    }

    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      networkErrorMessage;
    const detail = defaultErrorMessage + errorMessage;

    return Promise.reject({ error: true, message: detail });
  },
);

export default axiosInstance;
